import { THEME_COLOR } from "~/constants";

export function useLogoUrl() {
  const color = useColorMode();
  const appConfig = useRuntimeConfig().public;

  const CUSTOMER_LOGO_URL = {
    white: appConfig.APP_CUSTOMER.appearance.logo_white_url,
    black: appConfig.APP_CUSTOMER.appearance.logo_black_url,
    default: appConfig.APP_CUSTOMER.appearance.logo_url,
  };
  const logo_url = computed(() => {
    return (color?.value === THEME_COLOR.DARK ? CUSTOMER_LOGO_URL.black : CUSTOMER_LOGO_URL.white) || CUSTOMER_LOGO_URL.default || "";
  });

  return logo_url;
}
